// extracted by mini-css-extract-plugin
export default {"contact":"rskh0l","email":"HsARrC"};